/* Copyright (c) 2017 Backpack Health LLC */

import * as React from 'react'
import classnames from 'classnames';

import { BackpackThemedLoggedOutPageHeader, DashboardThemedPageHeader, GroupThemedPageHeader, GroupThemedLoggedOutPageHeader } from '../../../components/features/PageHeader';

import './ContentPanel.css';

interface Props {
  HeaderComponent: any;
  goBack?(): void;
  isFixedWidth?: boolean;
  hasMaxWidth?: boolean;
  subTitle?: string;
  mainTitle?: string;
  titlePhrase?: {
    id: string;
    values?: {};
  };
  withPadding?: boolean;
  hideHeaderBackgroundColor?: boolean;
}

export class AppHeader extends React.Component<{ HeaderComponent: any; hideHeaderBackgroundColor?: boolean; }, {}> {
  render() {
    const { HeaderComponent, hideHeaderBackgroundColor } = this.props;
    return (
      <div className="cmp-appheader">

        <div className={classnames('_content responsive-frame-content', { 'withBackgroundColor': !hideHeaderBackgroundColor })}>
          <HeaderComponent {...this.props} />
        </div>
      </div>
    );
  }
}

class ContentPanel extends React.Component<Props, {}> {
  constructor(props) {
    super(props);
    window.scroll(0, 0);
  }

  render() {
    const { isFixedWidth, withPadding, children, hasMaxWidth } = this.props;

    return (
      <div className={classnames("cmp-contentpanel", { 'fixedwidth': isFixedWidth })}>
        <AppHeader {...this.props} />

        <div className={classnames("cmp-contentpanel-content", { 'withPadding': withPadding, 'has-max-width': hasMaxWidth })}>
          {children}
        </div>
      </div>
    );
  }
}

export const GroupThemedContentPanelWithFullHeader = (props) => (
  <ContentPanel {...props} HeaderComponent={GroupThemedLoggedOutPageHeader} hideHeaderBackgroundColor={true} />
);

export const BackpackThemedContentPanelWithFullHeader = (props) => (
  <ContentPanel {...props} HeaderComponent={BackpackThemedLoggedOutPageHeader} hideHeaderBackgroundColor={true} />
);

export const DashboardThemedContentPanel = (props) => (
  <ContentPanel {...props} HeaderComponent={DashboardThemedPageHeader} />
);

export const GroupThemedContentPanel = (props) => (
  <ContentPanel {...props} HeaderComponent={GroupThemedPageHeader} />
);

export default GroupThemedContentPanel;
